module.exports = __webpack_public_path__ + "img/pt1.797eff11.png";